import { Injectable } from '@angular/core';
import {User} from "../models/User";
import {EsercizioUtente} from "../models/EsercizioUtente";
import {Piano} from "../models/Piano";
import {PVenditaUtente} from "../models/PVenditaUtente";


@Injectable({
   providedIn: 'root'
})
export class DataService {

   public static instance: DataService;

   public user: User = new User();

   public eserciziUser: EsercizioUtente[] = []; // esercizi dell'utente
   public esercizioUser: EsercizioUtente = new EsercizioUtente();
   public puntiVendita:PVenditaUtente[] = []

   public pianoAttivoEsercizio: Piano | null = null;
   public errors_plan: any[] = [];
   public warnings: any[] = [];
   public plan_is_valid:boolean = false;
   public plan_is_demo:boolean = false;
   public show_shopify:boolean = false;

   // impostati da auth guard
   public vendorSlug?: string;
   // public vendor?: Esercizio

   public dashboardData: any = {
      prodotti_count: 0,
      esercizi_count: 0,
      utenti_count: 0,
      da_approvare: 0,
   }
   public jwt;

   constructor() {
      DataService.instance = this;
   }
}
